<div class=" container mw-100 group-company-div visible-xs ">
    <nav class="navbar navbar-expand-lg navtext visible-flex-xs transparent p-0">
    <a class="navbar-brand" ><img src="/images/BHP_white.svg" alt="customlogo" width="50.65px" height="22px"></a>
    <a class="navbar-brand"><img src="/images/right_arrow.svg" alt="customlogo" width="24px" height="24px"></a>
  <span class="position-absolute group-company-dropdown text-white "><b>Inventory Management</b></span>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="nav-item dropdown position-absolute" style="right:0">
      <span name='account' class=" nav-link nav-border rounded-0 dropbtn" role="button" id="navbarDropdown3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>
      <div class="dropdown-menu account-dropdown mobdrop dropdown-content" aria-labelledby="navbarDropdown" >
       <!-- <h5 (click)="goToUpdatePersonalDetails()" [routerLink]="['profile/my-account/update-personal-details']"><a class="anchor-tag strong">Update Personal details</a></h5>
       <hr>
       <h5 (click)="goToResetPassword()" [routerLink]="['profile/my-account/change-password']" ><a class="anchor-tag strong">Reset Password</a></h5>
       <hr> -->
       <h5 [routerLink]="{ cxRoute : 'logout' } | cxUrl"><a class="anchor-tag strong">Logout</a></h5>
      </div>
</div>
</div>
</nav>

</div>

<div class='hidden-xs container mobile-inv'>
	<div class="hidden-xs-inv   navtext mobile-view-div d-flex justify-content-between">
		<div class="bhp-mobile"> 
      <a class="navbar-brand" ><img src="/images/BHP_white.svg" alt="customlogo"><img src="/images/right_arrow.svg" alt="customlogo" ><span class=" group-company-dropdown mobile-management text-white "><b>Inventory Management</b>
      </span></a>
</div>
<div class="nav-item dropdown inline-flex nav-icon-mobile-view">
    <span name='ipadaccount' class=" user-account-icon-btn " id="navbarDropdown5" role="button" aria-haspopup="true" aria-expanded="false">
      <!--<i class="fas fa-user-circle icon-style-mobile ipad-orientation fa-2x fa-mobile-icon"></i>-->
                </span>
              </div>
	</div>
   
</div>
<app-inventory-breadcrumb [navigationData]="navigationData" [pageTitle]="title">
</app-inventory-breadcrumb>
<div class="container d-flex justify-content-center py-5">
    <form (ngSubmit)="submitForm()" class="form-adjust" [formGroup]="loginForm" >
      <div class="form-group">
        <label>
          <span class=" strong">Username*</span>
          <input
            type="email"
            class="form-control form-control-lg text-secondary"
            formControlName="userId"
            placeholder="Enter Username"
          />
          <cx-form-errors [control]="loginForm.get('userId')" prefix="home"></cx-form-errors>
        </label>
      </div>
      <div class="form-group">
        <label>
          <span class=" strong">Password*</span>
          <input
            type="password"
            class="form-control form-control-lg text-secondary mt-2"
            placeholder="Password"
            formControlName="password"
          />
          <cx-form-errors [control]="loginForm.get('password')" prefix="home"></cx-form-errors>
        </label>
      </div>
      <!-- <p>
        <a
        [routerLink]="'/inventory/inventoryupdatepassword' | cxUrl"
          aria-controls="inventoryupdatepassword"
          class="small text-secondary text-decoration-underline text-black">Update password</a
        >
      </p> -->
      <button type="submit" [disabled]="isDisabled" class="btn btn-block btn-primary rounded-1 md-font">
       Sign in
      </button>

      <button type="button" class="btn btn-block btn-primary rounded-1 md-font" (click)="ssoSignIn()">
        SSO Sign in
       </button>
    </form>
  </div>
  
